module.exports = __webpack_public_path__ + "img/gallery02.ec289588.jpg";